import React, { useCallback, useMemo, useState } from 'react';
import { Header, Form, Button } from 'semantic-ui-react';
import { AdditionalVehicleFields } from './VehicleFields';
import styles from './VehicleMoreInformation.module.scss';
import CreditorSubForm from '../creditor/CreditorSubForm';
import { useErrors, useForm, useIsValid } from '../PolicyForm';
import moment from 'moment';

const VehicleMoreInformation = ({ data, onChange, onSaveAndExit, onContinue, onCancel, onBack, updateVehicle, vehicleState, addressLookup, addressState }) => {
	const [showErrors, setShowErrors] = useState(false);

	const _onChange = useCallback(
		(_, { name, value }) => {
			onChange({ [name]: value });
		},
		[onChange]
	);


	const canHaveLoanLeaseCoverage = useMemo(() => moment().get('year') - vehicleState.vehicle.year <= 5, [vehicleState.vehicle.year]);

	const formErrors = useErrors(data, AdditionalVehicleFields);
	const errors = useMemo(() => {
		const errors = { ...formErrors };
		if (!vehicleState.valid) errors.vehicleState = true;

		if(!canHaveLoanLeaseCoverage) {
			delete errors.hasThirdPartyLoanLeaseCoverage;
		}

		return errors;
	}, [canHaveLoanLeaseCoverage, formErrors, vehicleState.valid]);

	const isValid = useIsValid(errors);
	const form = useForm(AdditionalVehicleFields, data, errors, showErrors, _onChange);

	const _onContinue = useCallback(() => {
		if (isValid) {
			onContinue();
		} else {
			setShowErrors(true);
		}
	}, [isValid, onContinue]);

	const onHasThirdPartyLoanLeaseCoverageChange = useCallback(
		(value) => {
			onChange({ hasThirdPartyLoanLeaseCoverage: value, addLoanLeaseCoverage: null });
		},
		[onChange]
	);

	return (
		<div>
			<Header>We need some more information</Header>
			<Form>
				{canHaveLoanLeaseCoverage && (
					<Form.Group inline>
						<label className={styles.required}>{AdditionalVehicleFields.hasThirdPartyLoanLeaseCoverage.label}</label>
						<Form.Radio id="hasThirdPartyLoanLeaseCoverageYes" error={showErrors} name='hasThirdPartyLoanLeaseCoverage' label='Yes' onChange={() => onHasThirdPartyLoanLeaseCoverageChange(true)} checked={data.hasThirdPartyLoanLeaseCoverage === true} />
						<Form.Radio id="hasThirdPartyLoanLeaseCoverageNo" error={showErrors} name='hasThirdPartyLoanLeaseCoverage' label='No' onChange={() => onHasThirdPartyLoanLeaseCoverageChange(false)} checked={data.hasThirdPartyLoanLeaseCoverage === false} />
					</Form.Group>
				)}

				<CreditorSubForm form={form} onChange={_onChange} addressLookup={addressLookup} addressState={addressState} />
				<div className={styles.buttons}>
					<Button id="continueBtn" primary onClick={_onContinue}>
						Continue
					</Button>
					<Button id="saveAndExitBtn" primary onClick={onSaveAndExit}>
						Save and Exit
					</Button>
					<Button id="cancelBtn" primary onClick={onCancel}>
						Cancel
					</Button>
					<Button id="backBtn" primary onClick={onBack}>
						Back
					</Button>
				</div>
			</Form>
		</div>
	);
};

VehicleMoreInformation.propTypes = {};

export default VehicleMoreInformation;
